import { gtag, install } from 'ga-gtag';
import { noop } from 'lodash-es';

// eslint-disable-next-line import/no-mutable-exports
let gaInstance: Gtag.Gtag;

function setupGAInstance(trackingId:string) {
  if (trackingId) {
    install(trackingId, {
      send_page_view: false,
    });
    return gtag;
  }

  return noop;
}

if (!gaInstance) {
  gaInstance = setupGAInstance(window.GOOGLE_ANALYTICS_TRACKING_ID);
}

export default gaInstance;
